import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuickAddCompanyModel } from './quick-add-company.model';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { QuickAddCompanyApiService } from './quick-add-company-api.service';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'logzy-quick-add-company',
    templateUrl: './quick-add-company.component.html',
    styleUrls: ['./quick-add-company.component.scss']
})
export class QuickAddCompanyComponent implements OnInit {
    @Input()
    bindCompany = new BehaviorSubject(null);

    @Output()
    companyAdded = new EventEmitter()

    companyObj: QuickAddCompanyModel;
    disableSaveButton: boolean = false;

    country_url: string = `${ApiRoutes.Geo}country/?name=::search::`;
    state_url: string = `${ApiRoutes.Geo}state/?name=::search::`;


    constructor(private companyService: QuickAddCompanyApiService) { }

    ngOnInit(): void {
        this.companyObj = new QuickAddCompanyModel();
        this.bindCompany.subscribe(item => {
            if (item != null) {
                this.companyObj.saveCompanyPayloadToModel(item);
                this.state_url = `${ApiRoutes.Geo}state/?name=::search::&country=${this.companyObj.country.id}`;
            } else {
                this.companyObj = new QuickAddCompanyModel();
            }
        });
    }

    onCompanySave() {
        this.disableSaveButton = true
        if (this.companyObj.is_company_valid()) {
            this.companyService.addCompany(this.companyObj.getCompanySavePayload()).subscribe({
                next: response => {
                    this.companyAdded.emit(response);
                    return response;
                },
                error: error => {
                    this.companyObj.error = { ...error.error };
                    this.disableSaveButton = false
                    return error;
                }
            });
        } else {
            this.disableSaveButton = false
        }
    }

    filterStateByCountryId(event) {
        this.companyObj.country = event;
        if (event != null) {
            this.companyObj.state = null;
            this.companyObj.address = null;
            this.state_url = `${ApiRoutes.Geo}state/?name=::search::&country=${event.id}`;
        }
    }

    bindAddress(event) {
        this.companyObj.address = event?.name + ' , ' + this.companyObj.country?.name;
    }
}
